export default "__VITE_ASSET__BH9vyXuw__"